// extracted by mini-css-extract-plugin
module.exports = {"image-list":"style_image-list___KOqn","image-list-image":"style_image-list-image__rIZfo"};